<template>
  <div class="container big bb">
    <div class="flex align-center">
      <div style="width:100px;text-align:right">APPKEY：</div>
      <span>{{detail.appkey}}</span>
    </div>
    <div class="flex align-center" style="margin-top: 20px">
      <div style="width:100px;text-align:right">APPSECRET：</div>
      <span style="margin-right:20px">{{detail.appsecret}}</span>
      <el-button
        type="primary"
        size="mini"
        @click="setClinic(1)"
        :disabled="module_id_array[0]?!module_id_array.includes('396'):false"
      >重置</el-button>
    </div>
    <div class="flex align-center" style="margin-top: 20px">
      <div style="width:100px;text-align:right">通知地址：</div>
      <el-input v-model="detail.notice_url" placeholder="请输入" style="width:400px;margin-right:20px"></el-input>
      <el-button
        type="primary"
        @click="setClinic(2)"
        :disabled="module_id_array[0]?!module_id_array.includes('396'):false"
      >保存</el-button>
    </div>
    <div class="flex align-center" style="margin-top: 20px">
      <div style="width:100px;text-align:right">IP白名单：</div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 10}"
        placeholder="多个IP地址请用逗号隔开"
        v-model="detail.white_ip"
        style="width:400px;margin-right:20px"
      ></el-input>
      <el-button
        type="primary"
        @click="setClinic(3)"
        :disabled="module_id_array[0]?!module_id_array.includes('396'):false"
      >保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {}
    };
  },
  created() {
    this.getDetail();
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    }
  },
  methods: {
    //获取药房详情
    getDetail() {
      let clinic_id = this.$route.query.hospital_id;
      this.axios
        .post("platform/clinic/getClinicConfigInfo", { clinic_id })
        .then(res => {
          if (res.code == 0) {
            this.detail = res.data.info;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //开发配置
    setClinic(type) {
      let data = {
        type: type,
        clinic_id: this.$route.query.hospital_id
      };
      if (type == 2) {
        data.notice_url = this.detail.notice_url;
      }
      if (type == 3) {
        data.white_ip = this.detail.white_ip;
      }
      this.axios.post("platform/clinic/setClinicConfig", data).then(res => {
        if (res.code == 0) {
          this.$message.success("设置成功");
          this.getDetail();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  box-sizing: border-box;
  padding: 20px;
  text-align: left;
}
</style>
